import { initAnchorNavigation } from "modules/AnchorNavigation";
import "components/ModalForm/ModalForm";

(function (): void {
    initAnchorNavigation(".js-vertical-page-template");
})();
